export const selectTeamAssistant = ({
  assistants,
  preferredAssistantId,
  inboxId,
}) => {
  const available = Array.isArray(assistants) ? assistants : [];
  if (!available.length) return null;

  const preferredRef = String(preferredAssistantId || '');
  if (preferredRef) {
    const preferred = available.find(
      assistant => String(assistant?.id || '') === preferredRef
    );
    if (preferred) return preferred;
  }

  const inboxRef = String(inboxId || '');
  if (inboxRef) {
    const bound = available.find(assistant =>
      Array.isArray(assistant?.inbox_refs)
        ? assistant.inbox_refs.some(value => String(value) === inboxRef)
        : false
    );
    if (bound) return bound;
  }

  return available[0];
};
